import Link from 'components/Link'
import React from 'react'
import Header from '../Header'
import { graphql, useStaticQuery } from 'gatsby'
import Blog from './Blog'
import SearchIconButton from 'components/Search/SearchIconButton'
import CallToAction from '../CallToAction'
import { GitHub, LinkedIn, YouTube, Facebook2, Slack, Twitter } from 'components/Icons/Icons'
import { TwoCol, Wrapper, Block } from '../Wrapper'
import { MenuItem, MenuItem2 } from 'components/MainNav/Submenus/Products'

interface HowWeWorkNav {
    title: string
    url: string
}

const HomeColTitle = ({ linkListItem }) => {
    const { title, subtitle } = linkListItem
    let cta = linkListItem.cta
    if (Array.isArray(cta) && cta?.length == 1) {
        cta = cta[0]
    }
    if (cta?.enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        cta = null
    }
    return (
        <div className="mx-auto pt-0 pb-6 text-center md:px-6 md:pt-6">
            <h2 className="m-0 text-[15px] font-semibold text-black/40">{title}</h2>
            <h3
                className="mt-3 mb-0 text-2xl font-bold !leading-tight xl:text-3xl"
                dangerouslySetInnerHTML={{ __html: subtitle }}
            ></h3>
            {cta && (
                <CallToAction to={cta?.url} className="mt-3 !px-12">
                    {cta?.title}
                </CallToAction>
            )}
        </div>
    )
}
{
    /* <TwoCol
left={{
    title: 'Meeting?',
    cta: {
        url: '/book-a-meeting#qa',
        label: 'Book a meeting',
    },
    children: (
        <p className="m-0 text-[14px] dark:text-white">Let's jump into a quick chat</p>
    ),
}}
right={{
    title: 'Contact us',
    cta: { url: '/contact-us', label: 'Contact us' },
    children: (
        <p className="m-0 text-[14px] dark:text-white">
            Demo, license questions, integrations....
        </p>
    ),
}}
/> */
}
// right={{
//     title: 'Careers',
//     cta: { url: '/careers', label: 'Explore careers' },
//     children: (
//         <p className="m-0 text-[14px] dark:text-white">
//             We're currently hiring for{' '}
//             <strong>
//                 {careers?.totalCount || jobs?.totalCount} role
//                 {(careers?.totalCount > 1 || jobs?.totalCount > 1) && 's'}
//             </strong>
//             . We're unlike any company you've ever worked for.
//         </p>
//     ),
// }}
const HomeCol = ({ subitems, teamMembers, jobs, careers }) => {
    if (subitems?.enable?.toLowerCase?.() === 'false' && !process.env.RENDER_DISABLED_COMPONENTS) {
        return <></>
    }
    return (
        <>
            <div className="border-t border-dashed border-gray-accent-light">
                <div className="xl:max-w-auto mx-auto grid max-w-3xl divide-y divide-dashed divide-gray-accent-light sm:grid-cols-2 sm:divide-x sm:divide-y-0">
                    {subitems?.length > 0 &&
                        subitems
                            .filter((item) => {
                                if (process.env.RENDER_DISABLED_COMPONENTS) {
                                    return true // Include all items if RENDER_DISABLED_COMPONENTS is true
                                }
                                return item?.enable?.toLowerCase?.() !== 'false' // Exclude disabled items
                            })
                            .map((item, index) => {
                                return (
                                    <Block
                                        key={index}
                                        title={item.title}
                                        cta={{ url: item.url, label: item.description, enable: item.enable }}
                                    >
                                        {/* {item.title == 'Team' && (
                                            <p className="m-0 text-[14px] dark:text-white">
                                                Our <strong>{teamMembers?.totalCount} team members</strong> work from{' '}
                                                <strong>{teamMembers?.group.length} countries</strong>. Some travel
                                                full-time.
                                            </p>
                                        )} */}

                                        {item.title == 'Team' && (
                                            <p className="m-0 text-[14px] dark:text-white">
                                                Our <strong>{teamMembers?.totalCount} professionals</strong> excel in
                                                delivering outstanding results.
                                            </p>
                                        )}

                                        {item.title == 'Careers' && (
                                            <p className="m-0 text-[14px] dark:text-white">
                                                We're currently hiring for{' '}
                                                <strong>
                                                    {careers?.totalCount || jobs?.totalCount} role
                                                    {(careers?.totalCount > 1 || jobs?.totalCount > 1) && 's'}
                                                </strong>
                                                . We're unlike any company you've ever worked for.
                                            </p>
                                        )}
                                        {item.title != 'Careers' && item.title != 'Team' && (
                                            <p className="m-0 text-[14px] dark:text-white">{item.text}</p>
                                        )}
                                    </Block>
                                )
                            })}
                </div>
            </div>
        </>
    )
}
const HowWeWork = ({ menu }: { menu: HowWeWorkNav[] }) => {
    return (
        <div className="mb-4 border-t border-b border-dashed border-gray-accent-light py-6 md:mb-0 md:border-b-0 md:py-7">
            <div className="xl:max-w-auto mx-auto max-w-3xl md:px-6">
                <div className="flex w-full items-center justify-between opacity-70">
                    <h3 className="m-0 text-[18px] font-bold  ">HowWeWork</h3>
                    <SearchIconButton location="howwework-dropdown" initialFilter="howwework" />
                </div>
                <p className="m-0 mt-2 text-[14px] dark:text-white">
                    We're complete and operate in public as much as we can.
                </p>
                <ol className="m-0 mt-5 list-none grid-flow-col grid-cols-2 grid-rows-6 p-0 md:grid">
                    {menu.map(({ title, url }: HowWeWorkNav, index) => {
                        return (
                            <li key={index} className="first:hidden">
                                <Link
                                    className="relative flex h-full items-center space-x-2 rounded px-2 py-2.5 hover:bg-tan/50 active:top-[1px] active:scale-[.99]"
                                    to={url}
                                >
                                    <span className="flex w-4 items-center text-center text-[14px] font-semibold leading-none text-black/30 dark:text-white">
                                        {index}.
                                    </span>
                                    <h3 className="m-0 text-base leading-none opacity-70">{title}</h3>
                                </Link>
                            </li>
                        )
                    })}
                </ol>
                <CallToAction to="/how-we-work" className="mt-4 !w-full">
                    Browse how-we-work
                </CallToAction>
            </div>
        </div>
    )
}

export default function Company({ referenceElement, menuItem }: { referenceElement: HTMLDivElement }) {
    const { teamMembers, jobs, careers } = useStaticQuery(query)
    const { linkList, title, socialList } = menuItem

    return (
        <Wrapper
            placement="bottom-end"
            referenceElement={referenceElement}
            className="w-full xl:max-w-4xl 2xl:max-w-5xl"
        >
            <section className="flex flex-col-reverse md:flex-col">
                <Header title={title} social={socialList} />
                <div className="p-4 md:flex md:p-0">
                    {linkList?.length > 0 &&
                        linkList.map((linkListItem, index) => {
                            const { items, title, type, enable } = linkListItem
                            if (
                                (enable === false || enable?.toLowerCase?.() === 'false') &&
                                !process.env.RENDER_DISABLED_COMPONENTS
                            ) {
                                return <></>
                            }
                            return (
                                <>
                                    {type != 'RightColWide' && (
                                        <div className="flex-grow border-dashed border-gray-accent-light md:border-r">
                                            <HomeColTitle key={index} linkListItem={linkListItem} />
                                            {items?.length > 0 &&
                                                items.map((item, index2) => {
                                                    if (
                                                        (item?.enable === false ||
                                                            item?.enable?.toLowerCase?.() === 'false') &&
                                                        !process.env.RENDER_DISABLED_COMPONENTS
                                                    ) {
                                                        return <></>
                                                    }
                                                    return (
                                                        <>
                                                            <HomeCol
                                                                key={index2}
                                                                subitems={item?.subitems}
                                                                teamMembers={teamMembers}
                                                                jobs={jobs}
                                                                careers={careers}
                                                            />
                                                        </>
                                                    )
                                                })}
                                        </div>
                                    )}
                                    {type == 'RightColWide' && <Blog key={index} linkListItem={linkListItem} />}
                                </>
                            )
                        })}
                </div>
            </section>
        </Wrapper>
    )
}

const query = graphql`
    {
        teamMembers: allMdx(filter: { fields: { slug: { regex: "/^/team//" } } }) {
            totalCount
            group(field: frontmatter___country) {
                fieldValue
            }
        }
        careers: allMdx(
            filter: {
                frontmatter: { slug: { regex: "/careers/" }, isListed: { eq: true } }
                parent: { internal: { type: { eq: "GoogleDocs" } } }
            }
        ) {
            totalCount
        }
        jobs: allIcloudreadyJobPosting(
            filter: { isListed: { eq: true }, parent: { internal: { type: { ne: "GoogleDocs" } } } }
        ) {
            totalCount
        }
    }
`
